// 验证是否为数字
export const isNumber = (value) => {
  const regExp = /^\d+$/;
  return regExp.test(value);
};

// 验证经度
export const isLongitude = (value) => {
  const regExp = /^-?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)$/;
  return regExp.test(value);
};

// 验证纬度
export const isLatitude = (value) => {
  const regExp =/^-?([1-8]?\d(\.\d+)?|90(\.0+)?)$/;
  return regExp.test(value);
};

// 验证电话号码
export const isJapanPhone = (value) => {
  const regExp = /^0.*/;
  return regExp.test(value);
};
